import { Reducer } from 'redux'
import { IGlobalMessagingState, IGlobalMessagingAction } from 'types/globalMessaging'
import { ACTION_TYPES } from 'utils/actions/globalMessaging'

const { HIDE_MESSAGE, SHOW_MESSAGE } = ACTION_TYPES

const globalMessagingReducer: Reducer<IGlobalMessagingState, IGlobalMessagingAction> = (
  state = {},
  action
) => {
  switch (action.type) {
    case SHOW_MESSAGE:
      return {
        ...state,
        message: action.payload,
      }

    case HIDE_MESSAGE: {
      return {
        ...state,
        message: state.message?.id === action.payload?.id ? undefined : state.message,
      }
    }

    default:
      return state
  }
}

export default globalMessagingReducer
